import { Component, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';

import { AuthService } from 'src/app/shared/services/auth.service';
import { BreadcrumbService } from 'src/app/shared/services/breadcrumb.service';
import { CoreService } from 'src/app/shared/services/core.service';
import { IndicatorService } from 'src/app/shared/services/indicator.service';
import { JwtService } from 'src/app/shared/services/jwt.service';
import { environment } from 'src/environments/environment';

import lodash from 'lodash';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss', '/src/assets/css/common-v2/main-custom.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {
  public appVersion = environment.version;

  private breadcrumbSubscription: Subscription;
  private logoutSubscription: Subscription;

  breadcrumbDataArray;
  currentUserEmail: any;
  currentAccountType: any;
  public currentUserGroups = [];
  private currentUserDetails = null;

  private userUpdateSubscription: Subscription = null;

  constructor(
    public router: Router,
    private breadcrumbService: BreadcrumbService,
    private authService: AuthService,
    private indicatorService: IndicatorService,
    private jwtService: JwtService,
    private renderer: Renderer2,
    private coreService: CoreService,
  ) { }

  ngOnInit() {
    // Get breadcrumb data form store.
    this.breadcrumbSubscription = this.breadcrumbService.breadcrumbsData.subscribe(
      (data) => this.breadcrumbDataArray = data,
    );

    this.userUpdateSubscription = this.authService.userUpdated$.subscribe({
      next: () => this.getUserData(),
    });

    this.getUserData();
  }

  ngOnDestroy() {
    if (this.breadcrumbSubscription) {
      this.breadcrumbSubscription.unsubscribe();
    }

    if (this.logoutSubscription) {
      this.logoutSubscription.unsubscribe();
    }

    if (this.userUpdateSubscription) {
      this.userUpdateSubscription.unsubscribe();
    }
  }

  logout() {
    const returnUrl = '/auth/login';

    this.logoutSubscription = this.authService.logout().subscribe(
      () => {
        this.router.navigate([returnUrl]);
        this.jwtService.destroyToken();
        this.indicatorService.success(null, 'Logout Successfully');
      },
      () => this.indicatorService.failed('Error', 'Problem in logout API'),
    );
  }

  async getUserData() {
    this.currentUserEmail = this.coreService.getCurrentUserEmail();
    this.currentAccountType = this.coreService.getCurrentAccountType();

    this.currentUserDetails = await this.coreService.getCurrentUserDetailsLazy();
    this.currentUserGroups = lodash.get(this.currentUserDetails, 'groups', []);
  }

  getUserGroupsText() {
    return this.currentUserGroups.join(', ');
  }

  shouldShowRestoreAction() {
    return this.authService.isImpersonationActive();
  }

  openDropDown() {
    // This method is for mobile view.
    this.renderer.addClass(document.body, 'mobile-topbar-toggle');
  }

  openSideBar() {
    // This method is for mobile view.
    this.renderer.addClass(document.body, 'aside-left-open');
  }

  openSettings() {
    this.coreService.settingsLocation = 'Header';
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate(['/setting']);
  }

  goBackFromImpersonation() {
    this.authService.restoreUserFromImpersonation();
  }
}
